import { AdvertisementsList } from "@/features/advertisements/components/advertisements-list";

export function AdvertisementsSplashPage() {
  return <AdvertisementsList />;
}